const toNumberOrNull = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
};

const toComparableId = (value: unknown): number | null => {
  if (typeof value === 'object' && value !== null) {
    return toNumberOrNull((value as { id?: unknown }).id);
  }
  return toNumberOrNull(value);
};

export const compareByNumericValue = (a: unknown, b: unknown): boolean => {
  const left = toComparableId(a);
  const right = toComparableId(b);
  if (left === null && right === null) {
    return true;
  }
  return left !== null && right !== null && left === right;
};
